import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const TABS = [
  { id: "under-construction", labelKey: "navPipelines" },
  { id: "built-projects", labelKey: "navBuilt" },
  { id: "archive", labelKey: "navArchive" },
  { id: "about", labelKey: "navAbout" },
  { id: "contact", labelKey: "navContact" },
];

export const Navigation = ({ onNavigate, isMobile }) => {
  const { isArabic, t } = useLanguage();

  return (
    <nav
      data-testid="primary-nav"
      className={`${isMobile ? "sticky top-0 z-50 bg-[var(--bg-board)]/90 backdrop-blur-md py-3 px-4 border-b border-[var(--grid-line)] flex gap-2 overflow-x-auto" : `fixed top-6 ${isArabic ? "left-6" : "right-6"} z-40 flex gap-2`}`}
    >
      {TABS.map((tab, i) => (
        <motion.button
          key={tab.id}
          data-testid={`nav-${tab.id}`}
          onClick={() => onNavigate(tab.id)}
          initial={{ opacity: 0, y: -8, rotate: i % 2 === 0 ? -2 : 2 }}
          animate={{ opacity: 1, y: 0, rotate: i % 2 === 0 ? -2 : 2 }}
          whileHover={{ y: -2, rotate: 0 }}
          transition={{ delay: 0.1 + i * 0.05, type: "spring", stiffness: 220, damping: 20 }}
          className="relative font-mono text-[10px] uppercase tracking-[0.2em] px-4 py-2 text-ink"
          style={{
            background: i % 2 === 0 ? "rgba(245, 226, 168, 0.7)" : "rgba(212, 220, 230, 0.7)",
            borderLeft: "1px dashed rgba(0,0,0,0.08)",
            borderRight: "1px dashed rgba(0,0,0,0.08)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
          }}
        >
          {t(tab.labelKey)}
        </motion.button>
      ))}
    </nav>
  );
};

export default Navigation;
